// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__ENuyC","checkboxCol":"Table_checkboxCol__2kYA7","emailCol":"Table_emailCol__2xQX5","actionCol":"Table_actionCol__3PnqQ"};